import { useIsMobileLayout } from "@dbn/omnichannel-design-system-g4p";
import { useState } from "react";
import { useFormatMessage } from "../../intl";
import { useAppContext } from "../../useAppContext";
import { Modal } from "@g4p/react-styleguide-library";
import cx from "classnames";
import * as classes from "../Dialogs/IFrameDialog.css";
import { useSBDeepLink } from "../useSBDeepLink";

const COOKIECONSENT_STORAGE_KEY = "cookieconsent";

function setPersistedCookieConsent() {
  try {
    localStorage.setItem(COOKIECONSENT_STORAGE_KEY, "true");
  } catch (e) {
    console.error("LocalStorage Error", e);
  }
}

function getPersistedCookieConsent(): boolean {
  try {
    return localStorage.getItem(COOKIECONSENT_STORAGE_KEY) === "true";
  } catch (e) {
    return false;
  }
}

type State = "hide" | "show";

export function CookiesConsent() {
  const formatMessage = useFormatMessage();
  const [status, setStatus] = useState<State>(
    getPersistedCookieConsent() ? "hide" : "show"
  );
  const appContext = useAppContext();
  const isMobileLayout = useIsMobileLayout();
  const sbExit = useSBDeepLink("Exit");
  const onExit = () =>
    appContext.apiParameters.channel === "SB_Remote"
      ? sbExit()
      : (window.location.href = appContext.config.PWSURL);

  const children = (
    <iframe
      // title={formatMessage("CookiesConsent.modal.title")}
      src={appContext.config.cookiesConsentInfoUrl}
      frameBorder={0}
      className={cx({
        [classes.iframeStyle]: !isMobileLayout,
        [classes.iframeStyleMobile]: isMobileLayout,
      })}
    />
  );

  switch (status) {
    case "hide":
      return null;
    case "show":
      return (
        <Modal
          maskClosable={false}
          onClose={onExit}
          okText={formatMessage("CookiesConsent.action")}
          mobileModalHeight={"90%"}
          isDrawerOnMobile={isMobileLayout}
          onOk={() => {
            setPersistedCookieConsent();
            setStatus("hide");
          }}
          cancelText={formatMessage("CancelButton")}
          onCancel={onExit}
          title={formatMessage("CookiesConsent.modal.title")}
          open={true}
          type={"info"}
          children={children}
        />
      );
  }
}
